import React, { useEffect, useState } from "react";
import { Button, Card, Form, notification, Skeleton, Spin } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useStoreUpdaterWithAPI } from "../../../../Hooks/UseStoreUpdaterWithApi";
import { ConverterConfigGrid } from "../../../../Common/UIConstants";
import { useSelector } from "react-redux";
import ConverterPopup from "../../../CommonScreens/CreateConverter";
import { CONFIGURATION_CONVERTER } from "../../../../Common/Constants";
import { APIConstants } from "../../../../Common/APIConstants";

const ConverterConfiguration = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {loading,makeRequest } = useStoreUpdaterWithAPI();
  const [rowData, setRowData] = useState([])
  const [isAdd, setIsAdd] = useState(false);
  const mode = useSelector((state) => state.darkMode);
  const[isloading,setISLoading]=useState(true)
  const [refetch,setRefetch]=useState(false);
  const { isdarkMode } = mode;
  const color = useSelector((state) => state.ThemeChange);
  console.log(color)

  useEffect(()=>{
    setTimeout(()=>{
      setISLoading(false)
    },2000)
  })

  useEffect(() => {
    if (location.pathname === `${CONFIGURATION_CONVERTER}/converter-add-popup`) {
      setIsAdd(true);

    } else {
      setIsAdd(false);

    }
  }, [location.pathname]);

  const handleNotification = (msg) => {
    notification.open({
      message: msg,
      type: msg.includes("successfully") ? "success" : "error",
      placement: 'topRight',
      duration: 3, 
    });
  };
  

  const handleAddPopup = () => {
    navigate(`${CONFIGURATION_CONVERTER}/converter-add-popup`);
  };

  const getReponse = () => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_CONFIG_CONVERTER}`,
    }).then((res) => {
      
      console.log("Converter:", res);
      if(res&&res.length){
        setRowData(res);
      }
    }).catch((err) => {
      handleNotification("Error fetching data");
    });
  };

  const refetchData = () => {
    getReponse(); 
  };

  useEffect(()=>{
    getReponse()
  },[refetch])


const handleDeleteSubmit = (siteID) => {
  try {
    makeRequest({
      type: APIConstants.DELETE,
      url: `${APIConstants.DELETE_CONFIG_CONVERTER}?SITEID=${siteID}&IsDelete=true`,
    }).then((res) => {
      if (res) {
       
        const updatedRowData = rowData.filter((item) => item.siteID !== siteID);
        setRowData(updatedRowData);
        setRefetch(!refetch)
       
        handleNotification("Converter successfully deleted!");
      }
    }).catch((error) => {
      console.error(error);
      handleNotification("An error occurred while deleting the converter.");
    });
  } catch (err) {
    console.error(err);
    handleNotification("An unexpected error occurred while deleting the converter.");
  }
};


return (
  <div>

    {
      isloading ?(
        <div>
          <Skeleton  active/>
        </div>
      ):(
        <Card className={`w-full h-auto dark ${isdarkMode ? 'darkmode border-0' : 'whitemode'} `}>
        <div className="flex justify-end">
          <Button onClick={handleAddPopup}  
           className="flex justify-center items-center secondary-btn mb-2"
           style={{ "--secondary-color": color.themeConfig.secondaryColor,"--primary-color": color.themeConfig.colorPrimary }}>
            Add Converter
          </Button>
        </div>
  
        <ConverterPopup
          isAdd={isAdd}
          setIsAdd={setIsAdd}
          title={"Converter Details"}
          refetch={refetch} 
          setRefetch={setRefetch} 
          refetchData={refetchData}
          width={600}
        />
          {
            rowData.length > 0&& 
              <div className="overflow-auto">
                <Spin indicator={<Spin size="large" />} spinning={loading}>
                  <ConverterConfigGrid 
                    data={rowData}
                    handleDeleteSubmit={handleDeleteSubmit}
                    refetch={refetch} 
                    setRefetch={setRefetch} 
                  />
                </Spin>
              </div>
          }
      </Card>
      )
    }
   
  </div>
);
}; 

export default ConverterConfiguration;
